import { ref, computed } from '@vue/composition-api'
import GeozoneDialog from '@/components/@geozone/GeozoneDialog'
import GeozoneCard from './components/GeozoneCard'

export default {
  name: 'GeozonesList',
  components: { GeozoneDialog, GeozoneCard },
  setup(_, context) {
    const { $store } = context.root
    const geozoneForm = ref(false)
    const geozonesList = computed(() => $store.getters['geozones/list'])

    const createGeozone = () => {
      geozoneForm.value = true
    }

    const update = () => {
      context.emit('update')
    }

    return {
      geozonesList,
      geozoneForm,
      createGeozone,
      update,
    }
  },
}
